import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=8d1e1f92&scoped=true&"
import script from "./CaseDetail.vue?vue&type=script&lang=js&"
export * from "./CaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=8d1e1f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1e1f92",
  null
  
)

export default component.exports